/* import __COLOCATED_TEMPLATE__ from './sq-walkthrough-popover.hbs'; */
/**
`sq-walkthrough-popover` is a green popover that displays progress and buttons for going to next steps.

This is a base component for walkthroughs and should not be used standalone. In Dashboard,
this is rendered by the walkthrough service. For information on how to create walkthroughs
in Dashboard, check out the [Walkthrough Popover Guide](/development/walkthrough.html).

```example
@title Basic Example

@controller-properties
{
  // this is just for demo. The steps are defined in the walkthrough objects
  currentStep: {text: "This is the walkthrough popover text!", buttonText: "Next"},
  actions: {
    fakeAction() {
      }
  }
}

@hbs
{{!-- this is just for demo. The walkthrough service handles rendering the component,
you won't need to add it anywhere --}}
{{sq-walkthrough-popover class="popover--fly-down popover--align-right pointer--top pointer--align-right"
                         isActive=true
                         step=currentStep
                         progressText="progress text"
                         next=(action "fakeAction")
                         close=(action "fakeAction")}}
```

### Parameters
@param {string} class - Classes for the component
@param {boolean} isActive - If the popover is active
@param {Object} step - The WalkthroughStep the popover is showing
@param {String} step.text - The text which appears in the body of the popover
@param {String} step.buttonText - The text for the "Next" button of the popover. If empty, the button will not render
@param {string} [progressText] - Otional string in footer to indicate what the number of the current step out of the total number
@param {action} [next] - Optional action for the button rendered with step.buttonText
@param {action} [close] - Optional action for the close icon on the popover

Sass dependencies at: `@square/glass-ui/addon/styles/@square/dialog/walkthrough/_walkthrough.scss`
*/

// See models/walkthrough.js for documentation

import { observer } from '@ember/object';
import SqPopoverComponent from '@square/glass-ui/components/sq-popover';
export default SqPopoverComponent.extend({
  classNames: ['popover--walkthrough', 'popover--popper'],
  step: null,
  isActive: null,
  progressText: null,
  // eslint-disable-next-line ember/no-observers
  scrollIntoView: observer('isActive', function () {
    const scrollParent = this.element.closest('.scroll-y');
    if (this.isActive && scrollParent) {
      const offsetTop = this.element.offsetTop;
      if (offsetTop >= scrollParent.scrollTop + scrollParent.offsetHeight) {
        scrollParent.scrollTo({
          top: offsetTop,
          behavior: 'smooth'
        });
      }
    }
  }),
  click(event) {
    event.stopPropagation();
  }
});